export default __webpack_public_path__ + "static/media/zoom-in.b8bfa4c1.svg";